// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"1be179c0","265":"75d670ae","697":"ad09274c"}[chunkId] + ".chunk.js";
};